interface SVGProps {
  style: React.CSSProperties;
  color: string;
}

const SVG = (props: SVGProps) => {
  const { color } = props;

  return (
    <svg style={props.style} width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.252 10.6187L35.8745 21.2412L25.252 31.8637"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.12451 21.2412H35.577" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SVG;
